(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/react/components/exclusions-survey.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/react/components/exclusions-survey.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Button,
  ReactBottomSheet
} = svs.ui;
const {
  ControlGroup,
  Option,
  Checkbox
} = svs.ui.ReactForm;
const {
  useState
} = React;
const trackInteraction = (e, forms, action) => {
  const arrayForms = Array.from(forms);
  let checked = arrayForms.filter(element => element.checked).map(element => element.id).toString();
  if (action === 'Closed') {
    checked = '-1';
  }
  e === null || e === void 0 || e.preventDefault();
  svs.components.analytics.trackEvent({
    action,
    category: 'ExclusionSurvey',
    opt_label: checked
  });
};
const texts = ['Jag har förlorat för mycket pengar', 'Jag har lagt för mycket tid på mitt spelande', 'Jag har haft svårt att planera mitt spelande', 'Annan orsak'];
const Sheet = () => {
  const [checkedItems, setCheckedItems] = useState(texts.map((text, idx) => ({
    id: idx + 1,
    checked: false,
    text
  })));
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showSheet, setShowSheet] = useState(true);
  const setCheckbox = id => {
    setCheckedItems(prev => prev.map(item => item.id === id ? _objectSpread(_objectSpread({}, item), {}, {
      checked: !item.checked
    }) : item));
  };

  const onBottomSheetStateChange = state => {
    if (state.state === 'closed') {
      trackInteraction(null, checkedItems, 'Closed');
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(ReactBottomSheet.BottomSheet, {
    behavior: "modal",
    headerTitle: "Varf\xF6r tog du en spelpaus?",
    isExpanded: true,
    isVisible: showSheet,
    onStateChange: state => {
      onBottomSheetStateChange(state);
    }
  }, React.createElement("p", {
    className: "padding-left-2 padding-top-2",
    style: {
      fontWeight: '500',
      fontSize: '17.5px'
    }
  }, "V\xE4lj ett eller flera alternativ"), React.createElement("div", {
    className: "padding-left-2"
  }, React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja ett alternativ",
    hasError: isSubmitted && !checkedItems.some(item => item.checked),
    v2: true
  }, checkedItems.map(checkedItem => React.createElement("div", {
    className: "padding-bottom-1",
    key: checkedItem.id
  }, React.createElement(Checkbox, {
    checked: checkedItem.checked,
    key: checkedItem.id,
    name: "question",
    onChange: () => setCheckbox(checkedItem.id),
    value: checkedItem.id
  }, checkedItem.text))), React.createElement(Option, null))), React.createElement(Option, null), React.createElement(ReactBottomSheet.BottomSheetFooter, {
    className: ""
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: e => {
      setIsSubmitted(true);
      if (checkedItems.some(item => item.checked)) {
        trackInteraction(e, checkedItems, 'Submit');
        setShowSheet(false);
      }
    }
  }, "Spara"))));
};
const ExclusionsSurvey = () => {
  const isMobile = svs.core.detect.formfactor.mobile();
  if (isMobile) {
    const el = document.getElementById('self-exclusion-overview');
    if (el && !document.getElementById('sheet-component')) {
      var _document$querySelect;
      const mountPoint = document.createElement('div');
      mountPoint.id = 'sheet-component';
      (_document$querySelect = document.querySelector('.js-react-container')) === null || _document$querySelect === void 0 || _document$querySelect.appendChild(mountPoint);
      ReactDOM.render(React.createElement(Sheet, null), mountPoint);
    }
    return;
  }
  const dialog = new svs.ui.dialog.Confirm({
    actions: [{
      title: 'Stäng',
      callback: (e, forms) => {
        trackInteraction(e, forms, 'Closed');
        dialog.close();
      }
    }, {
      callback: (e, forms) => {
        trackInteraction(e, forms, 'Submit');
        dialog.close();
      },
      title: 'Spara'
    }],
    area: svs.ui.dialog.area.POPUP,
    branding: svs.ui.dialog.branding.SPORT,
    icon: 'spelpaus',
    message: [{
      align: svs.ui.dialog.message.align.LEFT,
      text: '<h4>Välj ett eller flera alternativ</h4>',
      type: svs.ui.dialog.message.TEXT
    }, ...texts.map(text => ({
      align: svs.ui.dialog.message.align.LEFT,
      text,
      type: svs.ui.dialog.message.CHECKBOX,
      block: true
    }))],
    title: 'Varför tog du en spelpaus?'
  });
  svs.ui.dialog.api.add(dialog);
};
svs.accountservices.player_exclusions.ExclusionsSurvey = ExclusionsSurvey;

 })(window);